import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { FaFacebookF, FaWhatsapp, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import axios from "axios";
import "./NewApplyForm.css";
import { API_URL } from "./config";


export default function NewJobDetails() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showApplyForm, setShowApplyForm] = useState(false);

  // form states
  const [formData, setFormData] = useState({
    candidateId: "",
    candidateTempId: "",
    jobOrderId: "",
    name: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    location: "",
    designation: "",
    skill: "",
    experience: "",
    ctc: "",
    expected: "",
    notice: "",
    remark: "",
    file: null,
    filePath: "",
  });
  const [uploaded, setUploaded] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios
      .get(`${API_URL}/career/JoborderInfo?id=${id}`)
      .then((res) => setJob(res.data))
      .catch(() => setError("Could not fetch job details"))
      .finally(() => setLoading(false));
  }, [id]);

  // handle input changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setFormData((prev) => ({ ...prev, file: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // validation
  const validateForm = () => {
    let newErrors = {};
    if (!formData.file) newErrors.file = "CV is required (PDF only)";
    if (!formData.firstName.trim()) newErrors.firstName = "First Name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Phone must be 10 digits only (e.g., 8707805222)";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email format";
    if (!formData.skill.trim()) newErrors.skill = "Skill is required";
    if (!formData.experience.trim()) newErrors.experience = "Experience is required";
    if (!formData.ctc.trim()) newErrors.ctc = "CTC is required";
    if (!formData.expected.trim()) newErrors.expected = "Expected CTC is required";
    if (!formData.notice.trim()) newErrors.notice = "Notice Period is required";
    if (!formData.remark.trim()) newErrors.remark = "Remark is required";
    if (!formData.location.trim()) newErrors.location = "Location is required";
    if (!formData.designation.trim()) newErrors.designation = "Designation is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const handleUploadClick = async () => {
  if (!formData.file) {
    alert("Please select a PDF file first!");
    return;
  }

  try {
    setLoadingUpload(true);

    const data = new FormData();
    data.append("file", formData.file); // send only the file

    // Replace with your actual API endpoint
    const response = await fetch(`${API_URL}/Career/UploadCV`, {
      method: "POST",
      body: data,
    });

    if (!response.ok) throw new Error(`Upload failed: ${response.statusText}`);

    // Some APIs return plain text, so parse safely
    const result = await response.json().catch(() => ({}));
    console.log("Upload response:", result);

    // Auto-fill form fields
    setFormData((prev) => ({
      ...prev,
      filePath: result.filePath || "",
      firstName: result.firstName || prev.firstName,
      lastName: result.lastName || prev.lastName,
      email: result.email || prev.email,
      phone: result.mobileNo || prev.phone,
      location: String(result.city || prev.location),
      designation: String(result.designation || prev.designation),
      skill: String(result.skills || prev.skill),
      experience: String(result.relevantExp || prev.experience),
      ctc: String(result.ctc || prev.ctc),
      expected: String(result.expected || prev.expected),
      notice: String(result.notice || prev.notice),
      remark: String(result.remark || prev.remark),
      candidateTempId: String(result.candidateTempId || prev.candidateTempId),
    }));

    setUploaded(true);
    alert("CV uploaded & form auto-filled!");
  } catch (err) {
    console.error(err);
    alert("Error uploading CV: " + err.message);
  } finally {
    setLoadingUpload(false);
  }
};

  // submit application
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (!uploaded) {
      alert("Please upload your CV first!");
      return;
    }

    const payload = {
      CandidateId: 0,
      TempCandidateId: Number(formData.candidateTempId) || 0,
      JobOrderID: Number(formData.jobOrderId) || 0,
      Name: formData.name || "",
      FirstName: formData.firstName || "",
      LastName: formData.lastName || "",
      KeySkills: formData.skill || "",
      MobileNo: formData.phone || "",
      City: formData.location || "",
      StatusID: 0,
      Status: "",
      NoticePeriod: Number(formData.notice) || 0,
      CurrentCTC: Number(formData.ctc) || 0,
      TotalExp: Number(formData.experience) || 0,
      ExpectedCTC: Number(formData.expected) || 0,
      owner: "",
      dateAdded: "",
      dtDateAdded: new Date().toISOString(),
      Email1: formData.email || "",
      Location: formData.location || "",
      Designation: formData.designation || "",
      Remark: formData.remark || "",
      OwnerId: 0,
      RollId: 0,
      currentemployer: "",
      relevantexp: 0,
      jobposition: "",
      Recruiter: "",
      extracandidate: "",
      extrafieldvalues: "",
      extrafieldHeding: null,
      ID: 0,
      strID: "",
    };

    try {
      setSubmitting(true);
      const response = await fetch(`${API_URL}/Career/EmailCareerDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("Failed to submit details");
      alert("Application submitted successfully!");
      closeModal();
    } catch (err) {
      alert("Error submitting: " + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const closeModal = () => {
    setShowApplyForm(false);
    setFormData({
      candidateId: "",
      candidateTempId: "",
      jobOrderId: "",
      name: "",
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      location: "",
      designation: "",
      skill: "",
      experience: "",
      ctc: "",
      expected: "",
      notice: "",
      remark: "",
      file: null,
      filePath: "",
    });
    setUploaded(false);
    setErrors({});
  };

  // Styles
  const modalOverlay = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
  };
  const modalContent = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "90%",
    maxWidth: "800px",
    maxHeight: "90vh",
    overflowY: "auto",
  };
  const labelStyle = { fontWeight: "600", marginBottom: "6px" };
  const inputStyle = {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "15px",
  };
  const errorText = { color: "red", fontSize: "13px", marginTop: "4px" };
  const btn = {
    padding: "10px 20px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    color: "#fff",
    fontWeight: "500",
  };

  if (loading) return <p>Loading job details...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!job) return <p>Job not found.</p>;

  return (
    <div id="app-wrapper" style={{ minHeight: "500px" }}>
      <section id="breadcrumb-panel" className="mb-3" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div>
          <ul style={{ display: "flex", gap: "10px", listStyle: "none", padding: 0 }}>
            <li><a href="https://ats24.e4softwares.com">Home</a></li>
            <li><a href="https://atsdemo.e4softwares.com/Career">Job Openings</a></li>
            <li><a href="#">{job.title}</a></li>
          </ul>
          <h3 style={{ paddingLeft: "10px" }}>Job Openings</h3>
        </div>
      </section>

      <section id="job-banner" className="container-fluid services">
        <div id="banner-panel">
          <div>
            <h2 className="job-title">{job.title}</h2>
            <ul>
              <li><strong>{job.workLocation}</strong></li>
              <li style={{ position: "relative" }}>
                <button
                  className="btn-link share-link"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  SHARE <i className="fa fa-share-alt" aria-hidden="true"></i>
                </button>
                {showDropdown && (
                  <ul
                    style={{
                      position: "absolute",
                      backgroundColor: "#fff",
                      top: "100%",
                      left: 0,
                      padding: "10px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    }}
                  >
                    <li>
                      <a href={`https://www.facebook.com/share.php?u=https://atsdemo.e4softwares.com/career/careerDetails1/${job.strID}`} target="_blank" rel="noreferrer">
                        <FaFacebookF /> Facebook
                      </a>
                    </li>
                    <li>
                      <a href={`https://www.linkedin.com/shareArticle?mini=true&url=https://atsdemo.e4softwares.com/career/careerDetails1/${job.strID}`} target="_blank" rel="noreferrer">
                        <FaLinkedinIn /> LinkedIn
                      </a>
                    </li>
                    <li>
                      <a href={`https://wa.me/?text=https://atsdemo.e4softwares.com/career/careerDetails1/${job.strID}`} target="_blank" rel="noreferrer">
                        <FaWhatsapp /> WhatsApp
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/e4software_services/" target="_blank" rel="noreferrer">
                        <FaInstagram /> Instagram
                      </a>
                    </li>
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section id="features" className="container-fluid services">
        <div className="row">
          <div id="mid-panel" style={{ padding: "20px" }}>
            <div className="white-bg round-corner box-panel-body MB20">
              <div id="job-desc" className="PD24">
                <h3>Job Description</h3>
                <p><strong>Job Code:</strong> {job.jobOrderCode} | <strong>Job Title:</strong> {job.title}</p>
                <h3>Location: {job.location}</h3>
                <div dangerouslySetInnerHTML={{ __html: job.jobDescription }} />
                <p>{job.skills}</p>

                <button
                  className="btn btn-warning text-white fw-bold"
                  style={{ background: "#f18b2c", border: "none", borderRadius: "8px", padding: "10px 20px", cursor: "pointer" }}
                  onClick={() => {
                    setShowApplyForm(true);
                    setFormData((prev) => ({
                      ...prev,
                      jobOrderId: String(job.jobOrderCode || ""),
                    }));
                  }}
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showApplyForm && (
        <div style={modalOverlay} onClick={closeModal}>
          <div style={modalContent} onClick={(e) => e.stopPropagation()}>
            {/* <h3 style={{ marginBottom: "20px", color: "#1a73e8" }}>
              Apply for: {job.title}
            </h3> */}

            {/* Upload CV */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Attach CV (PDF only)</label>
              <input
                type="file"
                name="file"
                accept="application/pdf"
                onChange={handleChange}
                style={inputStyle}
              />
              {errors.file && <p style={errorText}>{errors.file}</p>}
              <button
                style={{ ...btn, backgroundColor: "#4caf50", marginTop: "10px" }}
                onClick={handleUploadClick}
                disabled={loadingUpload}
              >
                {loadingUpload ? "Uploading..." : "Upload"}
              </button>
            </div>

            {/* Form */}
            {uploaded && (
              <form onSubmit={handleSubmit}>
                <h4 style={{ marginBottom: "15px" }}>Candidate Information</h4>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
                  {[
                    { label: "First Name", name: "firstName" },
                    { label: "Last Name", name: "lastName" },
                    { label: "Email", name: "email" },
                    { label: "Phone", name: "phone" },
                    { label: "Location", name: "location" },
                    { label: "Designation", name: "designation" },
                    { label: "Skill", name: "skill" },
                    { label: "Experience", name: "experience" },
                    { label: "CTC", name: "ctc" },
                    { label: "Expected", name: "expected" },
                    { label: "Notice", name: "notice" },
                    { label: "Remark", name: "remark" },
                  ].map((f) => (
                    <div key={f.name} style={{ display: "flex", flexDirection: "column" }}>
                      <label style={labelStyle}>{f.label}</label>
                      <input
                        type="text"
                        name={f.name}
                        value={formData[f.name]}
                        onChange={handleChange}
                        style={inputStyle}
                      />
                      {errors[f.name] && <span style={errorText}>{errors[f.name]}</span>}
                    </div>
                  ))}
                </div>
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <button
                    type="submit"
                    style={{ ...btn, backgroundColor: "#ff5722" }}
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Submit "}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
